<template>
    <div class="function-editor">
        <div class="header">
            <div class="title">
                <IconButton :on-click="() => $emit('close')">
                    <i class="material-icons">arrow_back_ios</i>
                </IconButton>
                <span>{{ createMode ? $t("message.create") : $t("message.edit") }} {{ $t("message.aiFunction") }}</span>
            </div>
            <div class="description">{{ $t("message.aiFunctionDesc") }}</div>
        </div>
        <div class="content">
            <h4>{{ $t("message.functionName") }}</h4>
            <div class="input-wrapper">
                <input v-model="clone.name" type="text" @input="handleNameInput" />
                <div v-if="hasTurkishChars" class="error-message">
                    <i class="material-icons">warning</i>
                    {{ $t("chatbotv2.functionNameNoTurkish") }}
                </div>
            </div>
            <h4>{{ $t("message.functionDesc") }}</h4>
            <textarea v-model="clone.description"></textarea>

            <div class="parameters">
                <h4>{{ $t("chatbotv2.parameters") }}</h4>
                <FunctionParameter
                    v-for="(parameter, index) in clone.parameters"
                    :key="index"
                    v-model="clone.parameters[index]"
                    @delete="clone.parameters.splice(index, 1)"
                />
            </div>
            <SupsisButton @click="addParameter" primary ghost>
                <i class="material-icons">add</i>
                {{ $t("message.addParameter") }}
            </SupsisButton>

            <a-divider />
            <div class="actions">
                <SupsisButton primary @click="saveFunction">
                    <i class="material-icons">save</i>
                    <span>{{ $t("message.save") }}</span>
                </SupsisButton>
                <SupsisButton @click="() => $emit('close')" ghost>
                    <i class="material-icons">close</i>
                    <span>{{ $t("message.cancel") }}</span>
                </SupsisButton>
                <SupsisButton @click="() => $emit('deleted', clone)" danger v-if="!createMode">
                    <i class="material-icons">delete</i>
                    <span>{{ $t("message.delete") }}</span>
                </SupsisButton>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import IconButton from "../../../Settings/components/IconButton.vue";
import SupsisButton from "../../../Settings/components/SupsisButton.vue";
import _ from "lodash";
import FunctionParameter from "./FunctionParameter.vue";

export default Vue.extend({
    name: "FunctionEditor",
    components: { FunctionParameter, SupsisButton, IconButton },
    props: {
        value: {
            type: Object,
            default: () => ({
                name: "",
                description: "",
                parameters: [],
            }),
        },
        createMode: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            clone: _.cloneDeep(this.value),
            hasTurkishChars: false,
        };
    },
    methods: {
        handleNameInput(event) {
            let value = event.target.value;
            
            // Sadece boşlukları sil
            value = value.replace(/\s/g, '');
            
            // Input'u güncelle
            this.clone.name = value;
            event.target.value = value;
            
            // Türkçe karakter kontrolü
            this.checkTurkishChars();
        },
        
        checkTurkishChars() {
            const turkishChars = /[ğüşıöçĞÜŞİÖÇ]/;
            this.hasTurkishChars = turkishChars.test(this.clone.name);
        },
        addParameter() {
            this.clone.parameters.push({
                name: "product_name",
                description: "Name of the product",
                type: "string",
                required: true,
            });
        },
        saveFunction() {
            if (this.hasTurkishChars) {
                return;
            }
            this.$emit("save", this.clone);
        },
    },
});
</script>

<style scoped lang="scss">
.function-editor {
    margin: 30px;

    .header {
        display: flex;
        flex-direction: column;
        gap: 5px;

        .title {
            display: flex;
            gap: 10px;
            color: #22272d;
            font-size: 28px;
            font-weight: 700;
        }

        .description {
            color: #22272d;
            font-size: 18px;
            line-height: 23px;
            margin-top: 8px;
            margin-bottom: 10px;
        }
    }

    .content {
        display: flex;
        flex-direction: column;
        gap: 10px;
        padding: 20px;
        background-color: #f5f5f5;
        border-radius: 10px;

        input[type="text"],
        textarea {
            padding: 10px;
            border: 1px solid #ccc;
            border-radius: 5px;
            font-size: 16px;
            width: 100%;
        }

        textarea {
            height: 100px;
            resize: vertical;
        }

        h4 {
            font-size: 18px;
            font-weight: bold;
            color: #333;
        }
    }

    .parameters {
        display: flex;
        flex-direction: column;
        gap: 10px;

        .function-parameter {
            padding-bottom: 10px;
            border-bottom: 1px solid #ccc;
        }
    }

    .actions {
        display: flex;
        width: 100%;
        justify-content: flex-end;
        align-items: center;
        gap: 10px;
    }

    .input-wrapper {
        position: relative;
        width: 100%;
    }

    .error-message {
        color: #ff4d4f;
        font-size: 14px;
        margin-top: 5px;
        display: flex;
        align-items: center;
        gap: 5px;

        i {
            font-size: 18px;
        }
    }
}
</style>
